export const VOIE_SKILL_PREFIX = 'Perfectionnement de la voie - '

export function voieSlotSource(voie: string) {
	return `${VOIE_SKILL_PREFIX}${voie}`
}

/**
 * True when a CharacterPrayer's slotSource indicates it was auto-granted
 * by a Perfectionnement de la voie skill. Such prayers must not consume
 * regular prayer slots during allocation.
 */
export function isVoieGrantedSlotSource(slotSource: string | null | undefined) {
	return (
		typeof slotSource === 'string' && slotSource.startsWith(VOIE_SKILL_PREFIX)
	)
}
